<template>
  <div>
    <div class="work-flow-step" v-if="type === 'A'">
      <ul>
        <li
          class="work-flow-step-list"
          v-for="(item, index) in workFlowListStep"
          :key="index"
          :class="item.listClass"
        >
          <span class="work-flow-step-txt">{{ item.title }}</span>
        </li>
      </ul>
    </div>
    <template v-if="type === 'B'">
      <div
        class="work-flow"
        :class="[workFlowList.classDetail, workFlowList.size]"
        @click="clickFlow(flowDepth)"
      >
        <i v-if="workFlowList.check" class="el-icon-circle-check checked"></i>
        <span class="work-flow-item">{{ workFlowList.title }}</span>
        <div class="work-flow-right">
          <i
            v-if="workFlowList.oneDepth"
            class="el-icon-arrow-right one-depth"
          ></i>
          <el-button
            v-if="workFlowList.setting"
            icon="el-icon-setting"
            class="btn-icon"
            @click="onSetting(row, col, settingType)"
          />
          <el-button
            v-if="workFlowList.plus"
            icon="el-icon-circle-plus-outline"
            class="btn-icon"
            @click="onPlus(row, col, settingType)"
          />
          <el-button
            v-if="workFlowList.remove"
            icon="el-icon-remove-outline"
            class="btn-icon"
            @click="onMinus(row, col, settingType)"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    flowDepth: {
      type: Object,
      default: () => {},
    },
    workFlowList: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: "B",
    },
    workFlowListStep: {
      type: Array,
      default: () => [],
    },
    row: {
      type: Number,
      default: 0,
    },
    col: {
      type: Number,
      default: 0,
    },
    settingType: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    onSetting(row, col, settingType) {
      this.$EventBus.$emit("onSetting", row, col, settingType);
    },
    onPlus(row, col, settingType) {
      this.$EventBus.$emit("onPlus", row, col, settingType);
    },
    onMinus(row, col, settingType) {
      this.$EventBus.$emit("onMinus", row, col, settingType);
    },
    clickFlow(data) {
      if (data.oneDepth) {
        this.$EventBus.$emit("clickFlow", data.oneDepth);
      } else {
        this.$EventBus.$emit("clickFlow", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.work-flow {
  cursor: pointer;
  display: flex;
  min-height: 36px;
  line-height: 1;
  padding: 10px 7px;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  &.large {
    min-height: 40px;
    .work-flow-item {
      font-size: $--font-size-base;
      font-weight: $--font-weight-Medium;
    }
  }
  &.small {
    margin-left: 10%;
  }
  &.wait {
    border: 1px solid $--work-flow-wait-border-color;
    color: $--work-flow-wait-font-color;
  }
  &.default {
    border: 1px solid $--work-flow-default-color;
    color: $--work-flow-wait-font-color;
    font-weight: $--font-weight-Medium;
    .btn-icon {
      color: $--work-flow-default-color;
    }
    &-sub {
      border: 1px solid $--work-flow-default-sub-color;
      color: $--work-flow-default-color;
      .btn-icon {
        color: $--work-flow-default-color;
      }
    }
  }
  &.pend {
    border: 1px solid $--work-flow-pend-background-color;
    background-color: $--work-flow-pend-background-color;
    color: $--color-white;
  }
  &.default-end {
    border: 1px solid $--work-flow-default-doing-background-color;
    background-color: $--work-flow-default-end-background-color;
    color: $--work-flow-default-end-font-color;
  }
  &.default-doing {
    border: 1px solid $--work-flow-default-doing-background-color;
    background-color: $--work-flow-default-doing-background-color;
    color: $--color-white;
  }
  &-right {
    position: absolute;
    right: 7px;
  }
  .checked {
    margin-right: 5px;
  }
  border-radius: 5px;
  &-item {
    display: block;
    max-width: 120px;
    font-size: $--font-size-small;
    min-width: 70px;
    letter-spacing: -1.5px;
  }
  .btn-icon {
    border: 0;
    background-color: transparent;
    padding: 0;
  }
  .el-button + .el-button {
    margin-left: 7px;
  }
  &-step {
    &-list {
      display: inline-block;
      color: $--work-flow-default-color;
      &:not(:last-child) {
        margin-right: 18px;
      }
      &::before {
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-right: 5px;
        vertical-align: middle;
        border-radius: 50%;
        content: "";
      }
      &.wait::before {
        background: $--work-flow-wait-border-color;
      }
      &.doing::before {
        background: $--work-flow-default-doing-background-color;
      }
      &.pend::before {
        background: $--work-flow-pend-background-color;
      }
      &.end::before {
        background: $--work-flow-default-end-background-color;
      }
    }
    &-txt {
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
